<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-6">
          <label class="label-input">Section background</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="e => (fields.textColor = e.target.value)"
                  />
                  <v-text-field v-model="fields.textColor" label="Text color" :hide-details="true" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['background-section'].color"
                    @change="e => (fields['background-section'].color = e.target.value)"
                  />
                  <v-text-field v-model="fields['background-section'].color" label="Background" :hide-details="true" />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.top" label="Top padding" :hide-details="true" />
              </v-col>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.bottom" label="Bottom padding" :hide-details="true" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <label class="label-input">Container content</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields['container-content'].showStyle" label="Show style" />
              </v-col>
              <v-col cols="12" md="8">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-content'].background"
                    @change="e => (fields['container-content'].background = e.target.value)"
                  />
                  <v-text-field v-model="fields['container-content'].background" label="Container background" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <label class="label-input">Left Card</label>
          <div class="group-item">
            <label class="label-input-sub">-- Title block</label>
            <div class="mb-4">
              <div class="group-item">
                <v-checkbox
                  class="mb-3 mt-0"
                  v-model="fields.titleCardLeft.show"
                  label="Show title block"
                  :hide-details="true"
                />
                <ckeditor :editor="editor" v-model="fields.titleCardLeft.content" :config="editorConfig" />
              </div>
            </div>

            <div class="mb-4">
              <div class="label-input-sub">-- Highlight block</div>
              <div class="group-item">
                <v-checkbox class="mt-0 mb-0" v-model="fields.highlightGroup.show" label="Show highlight block" />
                <div class="d-flex align-center gap-3 mb-2">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.highlightGroup.background"
                    @change="e => (fields.highlightGroup.background = e.target.value)"
                  />
                  <v-text-field v-model="fields.highlightGroup.background" label="Highlight background" />
                </div>
                <!-- <label class="label-input">Highlight block</label> -->
                <ckeditor :editor="editor" v-model="fields.highlightGroup.content" :config="editorConfig" />
              </div>
            </div>

            <div class="mb-4">
              <div class="label-input-sub">-- Button</div>
              <div class="group-item">
                <v-row>
                  <v-col cols="12">
                    <v-checkbox
                      class="mt-0 mb-0"
                      v-model="fields.btnCardLeft.show"
                      label="Show button left"
                      :hide-details="true"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="fields.btnCardLeft.text" label="Button text" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="fields.btnCardLeft.url" label="Button URL" />
                  </v-col>
                  <v-col cols="12" md="12">
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields.btnCardLeft.color"
                        @change="e => (fields.btnCardLeft.color = e.target.value)"
                      />
                      <v-text-field v-model="fields.btnCardLeft.color" label="Button color" />
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Right Card</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="rightCardPosition"
                  :items="positionOptions"
                  item-text="text"
                  item-value="value"
                  label="Position"
                />
              </v-col>
            </v-row>
            <div class="mb-4">
              <div class="d-flex justify-space-between align-center mb-2">
                <label class="label-input-sub" style="margin-bottom: 0">-- Accordion Items</label>
                <v-btn small color="primary" @click="handleAddAccordion">
                  <v-icon size="16">mdi-plus</v-icon>
                  <span>Add Item</span>
                </v-btn>
              </div>
              <div class="group-item">
                <v-checkbox
                  class="mt-0 mb-3"
                  v-model="fields.itemAccordions.dataShowAccordion"
                  label="Show accordion list"
                  :hide-details="true"
                />
                <v-expansion-panels accordion>
                  <v-expansion-panel v-for="(item, index) in fields.itemAccordions.listItem" :key="index">
                    <v-expansion-panel-header>
                      <div class="d-flex justify-space-between align-center">
                        <div class="line-clamp-1">{{ item.title || `Item ${index + 1}` }}</div>
                        <v-btn icon @click.stop="handleRemoveAccordion(index)">
                          <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-text-field v-model="item.title" label="Title" />
                      <label class="label-input">Answer</label>
                      <ckeditor :editor="editor" v-model="item.answer" :config="editorConfig" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

export default {
  name: 'FaqVitalSectionEditor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'FAQ Vital Section',
        enableAnchor: false,
        textColor: '#07476e',
        padding: { top: true, bottom: true },
        'background-section': { color: '#9cdbe8' },
        'container-content': { showStyle: false, background: '#ffffff' },
        leftCard: { order: 1 },
        titleCardLeft: { show: true, content: '' },
        highlightGroup: { show: true, content: '', background: '#daecf0' },
        btnCardLeft: { show: true, text: '', url: '#', color: '#214a88' },
        rightCard: { order: 2 },
        itemAccordions: { dataShowAccordion: true, listItem: [] },
      },
      positionOptions: [
        { text: 'Left', value: 'left' },
        { text: 'Right', value: 'right' },
      ],
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
    this.syncOrderByRightPosition(this.rightCardPosition);
  },
  computed: {
    rightCardPosition: {
      get() {
        return Number(this.fields.rightCard.order) === 1 ? 'left' : 'right';
      },
      set(value) {
        this.syncOrderByRightPosition(value);
      },
    },
  },
  methods: {
    syncOrderByRightPosition(value) {
      if (value === 'left') {
        this.fields.rightCard.order = 1;
        this.fields.leftCard.order = 2;
      } else {
        this.fields.rightCard.order = 2;
        this.fields.leftCard.order = 1;
      }
    },
    handleAddAccordion() {
      this.fields.itemAccordions.listItem.push({
        title: 'New question',
        answer: '<p>New answer</p>',
      });
    },
    handleRemoveAccordion(index) {
      this.fields.itemAccordions.listItem.splice(index, 1);
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFaqVital(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.label-input-sub {
  font-size: 16px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 6px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.ck-editor__editable_inline {
  min-height: 160px;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
